/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BackendSiteSettingsParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['MAX_FILE_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_LARGE_UPLOAD_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_NORMAL_UPLOAD_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'DEFAULT_COURSE_TA_ROLE',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('Full TA', 'Non-Editing TA')),
    ],
    [
        'DEFAULT_COURSE_TEACHER_ROLE',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('Full Teacher', 'Non-Editing Teacher')),
    ],
    [
        'DEFAULT_COURSE_TIER',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('advanced', 'free', 'starter')),
    ],
    [
        'NEW_AUTO_TEST_DEFAULT_OS',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('Ubuntu 20.04', 'Ubuntu 24.04')),
    ],
    ['SEND_REGISTRATION_EMAIL', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['JWT_ACCESS_TOKEN_EXPIRES', /* #__PURE__ */ codecOptional(parsers.duration)],
    ['MIN_PASSWORD_SCORE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['POW_DIFFICULTY', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'PAYMENTS_PROVIDER',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.exactly('paddle', 'stripe')),
    ],
    ['PER_COURSE_PAYMENT_ALLOWED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['HUBSPOT_SYNCING_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'LTI_1P3_NONCE_AND_STATE_VALIDATION_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'LTI_1P3_SYSTEM_ROLE_FROM_CONTEXT_ROLE',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['LTI_LAUNCH_DATA_LOGGING', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['LTI_ROLE_SWITCHING', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['NAME_AND_EMAIL_FROM_NRPS_ONLY', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'SSO_USERNAME_DECOLLISION_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
]));
export class BackendSiteSettings extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BackendSiteSettingsParser.decode(input).map(res => new BackendSiteSettings(res));
    }
    static unsafeDecode(input) {
        return BackendSiteSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BackendSiteSettingsParser.encode(data);
    }
    static schema() {
        return BackendSiteSettingsParser.schema();
    }
}
